import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/free-pentest/pentest-client.tsx");
